module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Heavy.28117b03.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Heavy.ttf
// module id = 2544
// module chunks = 7